// helpDeskActions.js
export const GET_MESSAGES = "GET_MESSAGES";
export const SET_MESSAGES = "SET_MESSAGES";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const DELETE_MESSAGE = "DELETE_MESSAGE";
export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const UPDATE_MESSAGE_TYPE = "UPDATE_MESSAGE_TYPE";
export const FETCH_DIVISION_OPTIONS = "FETCH_DIVISION_OPTIONS";
export const UPDATE_DIVISION = "UPDATE_DIVISION";
export const UPDATE_DIVISION_MESSAGE = "UPDATE_DIVISION_MESSAGE";
export const SUBMIT_MESSAGE = "SUBMIT_MESSAGE";
export const OPEN_DELETE_POPUP = "OPEN_DELETE_POPUP";
export const CLOSE_DELETE_POPUP = "CLOSE_DELETE_POPUP";
export const OPEN_DELETE_SUCCESS_POPUP = "OPEN_SUCCESS_POPUP";
export const CLOSE_DELETE_SUCCESS_POPUP = "CLOSE_SUCCESS_POPUP";
export const OPEN_SUBMIT_SUCCESS_POPUP = "OPEN_SUBMIT_SUCCESS_POPUP";
export const CLOSE_SUBMIT_SUCCESS_POPUP = "CLOSE_SUBMIT_SUCCESS_POPUP";
export const GET_DIVISION = `GET_DIVISION`;
export const SET_DIVISION = `SET_DIVISION`;
export const CREATEMSG_STATUS_MESSAGE = `CREATEMSG_STATUS_MESSAGE`;
export const DELETE_STATUS_MESSAGE = `DELETE_STATUS_MESSAGE`;
export const EDIT_TRUE = "EDIT_TRUE";
export const EDIT_FALSE = "EDIT_FALSE";
export const EDIT_MESSAGE_REQUEST = "EDIT_MESSAGE_REQUEST";
export const EDIT_MESSAGE_SUCCESS = "EDIT_MESSAGE_SUCCESS";
export const EDIT_MESSAGE_FAILURE = "EDIT_MESSAGE_FAILURE";
export const SET_SERIAL_NUMBER_TO_EDIT = "SET_SERIAL_NUMBER_TO_EDIT";
export const CLEAR_SERIAL_NUMBER_TO_EDIT = "CLEAR_SERIAL_NUMBER_TO_EDIT";
export const GET_ARCHIVE_MESSAGES_REQUEST = "GET_ARCHIVE_MESSAGES_REQUEST";
export const GET_ARCHIVE_MESSAGES_SUCCESS = "GET_ARCHIVE_MESSAGES_SUCCESS";
export const GET_ARCHIVE_MESSAGES_FAILURE = "GET_ARCHIVE_MESSAGES_FAILURE";
export const SET_ARCHIVE_MESSAGES = "SET_ARCHIVE_MESSAGES";
export const CLEAR_ARCHIVE_MESSAGES = "CLEAR_ARCHIVE_MESSAGES";
export const ACTIVATE_MESSAGE_REQUEST = "ACTIVATE_MESSAGE_REQUEST";
export const ACTIVATE_MESSAGE_SUCCESS = "ACTIVATE_MESSAGE_SUCCESS";
export const ACTIVATE_MESSAGE_FAILURE = "ACTIVATE_MESSAGE_FAILURE";
export const CLEAR_ACTIVATION_RESPONSE = "CLEAR_ACTIVATION_RESPONSE";
export const ACTIVATE_POPUP_STATUS_MSG = "ACTIVATE_POPUP_STATUS_MSG";
export const OPEN_ACTIVATE_SUCCESS_POPUP = "OPEN_ACTIVATE_SUCCESS_POPUP";
export const CLOSE_ACTIVATE_SUCCESS_POPUP = "CLOSE_ACTIVATE_SUCCESS_POPUP";
export const FETCH_MESSAGE_TYPES_REQUEST = "FETCH_MESSAGE_TYPES_REQUEST";
export const FETCH_MESSAGE_TYPES_SUCCESS = "FETCH_MESSAGE_TYPES_SUCCESS";
export const FETCH_MESSAGE_TYPES_FAILURE = "FETCH_MESSAGE_TYPES_FAILURE";
export const SET_PAGENO_HELPDESK = "SET_PAGENO_HELPDESK";
export const SET_PAGESIZE_HELPDESK = "SET_PAGESIZE_HELPDESK";
export const SET_TOTALPAGES_HELPDESK = "SET_TOTALPAGES_HELPDESK";
export const SET_TOTALRECORDS_HELPDESK = "SET_TOTALRECORDS_HELPDESK";

export const openSubmitSuccessPopup = () => ({
	type: OPEN_SUBMIT_SUCCESS_POPUP,
});

export const closeSubmitSuccessPopup = () => ({
	type: CLOSE_SUBMIT_SUCCESS_POPUP,
});

export const openDeleteSuccessPopup = () => ({
	type: OPEN_DELETE_SUCCESS_POPUP,
});

export const closeDeleteSuccessPopup = () => ({
	type: CLOSE_DELETE_SUCCESS_POPUP,
});

export const openDeletePopup = (serialNumber) => ({
	type: OPEN_DELETE_POPUP,
	payload: serialNumber,
});

export const closeDeletePopup = () => ({
	type: CLOSE_DELETE_POPUP,
});

export const getMessages = () => ({
	type: GET_MESSAGES,
	// payload: messages,
});

export const setMessages = (messages) => ({
	type: SET_MESSAGES,
	payload: messages,
});

export const addMessage = (message) => ({
	type: ADD_MESSAGE,
	payload: message,
});

export const deleteMessage = (serialNumber) => ({
	type: DELETE_MESSAGE,
	payload: serialNumber,
});

export const openModal = () => ({
	type: OPEN_MODAL,
});

export const closeModal = () => ({
	type: CLOSE_MODAL,
});

export const updateMessageType = (messageType) => ({
	type: UPDATE_MESSAGE_TYPE,
	payload: messageType,
});

export const fetchDivisionOptions = (divisionOptions) => ({
	type: FETCH_DIVISION_OPTIONS,
	payload: divisionOptions,
});

export const updateDivision = (division) => ({
	type: UPDATE_DIVISION,
	payload: division,
});

export const updateDivisionMessage = (divisionMessage) => ({
	type: UPDATE_DIVISION_MESSAGE,
	payload: divisionMessage,
});

export const submitMessage = () => ({
	type: SUBMIT_MESSAGE,
});

export const getDivision = () => ({
	type: GET_DIVISION,
});
export const setDivision = (data) => ({
	type: SET_DIVISION,
	value: data,
});

export const deletePopUpStatusMsg = (deletePopUpStatusMessage) => ({
	type: DELETE_STATUS_MESSAGE,
	payload: deletePopUpStatusMessage,
});

export const createNewMessagePopUpStatusMsg = (
	createNewMessagePopUpStatusMessage
) => ({
	type: CREATEMSG_STATUS_MESSAGE,
	payload: createNewMessagePopUpStatusMessage,
});

export const editTrue = () => ({
	type: EDIT_TRUE,
});

export const editFalse = () => ({
	type: EDIT_FALSE,
});

export const editMessageRequest = (message) => ({
	type: EDIT_MESSAGE_REQUEST,
	payload: message,
});

export const editMessageSuccess = (message) => ({
	type: EDIT_MESSAGE_SUCCESS,
	payload: message,
});

export const editMessageFailure = (error) => ({
	type: EDIT_MESSAGE_FAILURE,
	payload: error,
});

export const setSerialNumberToEdit = (serialNumber) => ({
	type: SET_SERIAL_NUMBER_TO_EDIT,
	payload: serialNumber,
});

export const clearSerialNumberToEdit = () => ({
	type: CLEAR_SERIAL_NUMBER_TO_EDIT,
});

export const getArchiveMessagesRequest = (pageNumber, pageSize, sortOrder) => ({
	type: GET_ARCHIVE_MESSAGES_REQUEST,
	payload: { pageNumber, pageSize, sortOrder },
});

export const getArchiveMessagesSuccess = (messages) => ({
	type: GET_ARCHIVE_MESSAGES_SUCCESS,
	payload: messages,
});

export const getArchiveMessagesFailure = (error) => ({
	type: GET_ARCHIVE_MESSAGES_FAILURE,
	payload: error,
});

export const setArchiveMessages = (messages) => ({
	type: SET_ARCHIVE_MESSAGES,
	payload: messages,
});

export const clearArchiveMessages = () => ({
	type: CLEAR_ARCHIVE_MESSAGES,
});

export const activateMessageRequest = (message) => ({
	type: ACTIVATE_MESSAGE_REQUEST,
	payload: message,
});

export const activateMessageSuccess = (response) => ({
	type: ACTIVATE_MESSAGE_SUCCESS,
	payload: response,
});

export const activateMessageFailure = (error) => ({
	type: ACTIVATE_MESSAGE_FAILURE,
	payload: error,
});

export const clearActivationResponse = () => ({
	type: CLEAR_ACTIVATION_RESPONSE,
});

export const activatePopUpStatusMsg = (message) => ({
	type: ACTIVATE_POPUP_STATUS_MSG,
	payload: message,
});

export const openActivatePopup = () => ({
	type: OPEN_ACTIVATE_SUCCESS_POPUP,
});

export const closeActivatePopup = () => ({
	type: CLOSE_ACTIVATE_SUCCESS_POPUP,
});

export const fetchMessageTypesRequest = () => ({
	type: FETCH_MESSAGE_TYPES_REQUEST,
});

export const fetchMessageTypesSuccess = (messageTypes) => ({
	type: FETCH_MESSAGE_TYPES_SUCCESS,
	payload: messageTypes,
});

export const fetchMessageTypesFailure = (error) => ({
	type: FETCH_MESSAGE_TYPES_FAILURE,
	payload: error,
});

export const setPageNoHelpDesk = (pageNo) => ({
	type: SET_PAGENO_HELPDESK,
	payload: pageNo,
});

export const setPageSizeHelpDesk = (pageSize) => ({
	type: SET_PAGESIZE_HELPDESK,
	payload: pageSize,
});

export const setTotalPagesHelpDesk = (totalPages) => ({
	type: SET_TOTALPAGES_HELPDESK,
	payload: totalPages,
});

export const setTotalRecordsHelpDesk = (totalRecords) => ({
	type: SET_TOTALRECORDS_HELPDESK,
	payload: totalRecords,
});
